import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "74.5 0 45 45",
  "enable-background": "new 74.5 0 45 45",
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("polygon", {
      fill: "currentColor",
      points: "102.4,6.8 103.2,7.6 104.1,4.2 100.7,5.1 101.5,5.9 80.5,27 79.6,26.2 78.7,29.6 82.1,28.6 \n\t81.3,27.8 "
    }, null, -1),
    _createElementVNode("circle", {
      fill: "currentColor",
      cx: "109",
      cy: "13.1",
      r: "1.2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M114.9,12c-1.6-1.6-3.3-3.3-4.9-4.9c-1.1-1.1-2.8-1.1-3.9,0c-8,8-15.9,15.9-23.9,23.9\n\tc-1.1,1.1-1.1,2.8,0,3.9c1.6,1.6,3.3,3.3,4.9,4.9c1.1,1.1,2.8,1.1,3.9,0c8-8,15.9-15.9,23.9-23.9C116,14.8,116,13.1,114.9,12z\n\t M113.5,14.5c-8,8-15.9,15.9-23.9,23.9c-0.3,0.3-0.7,0.3-1,0c-1.6-1.6-3.3-3.3-4.9-4.9c-0.3-0.3-0.3-0.7,0-1c0.5-0.5,1-1,1.5-1.5\n\tc0.5,0.5,1,1,1.5,1.5c0.3-0.3,0.6-0.6,1-1c-0.5-0.5-1-1-1.5-1.5c0.7-0.7,1.3-1.3,2-2c0.8,0.8,1.6,1.6,2.4,2.4c0.3-0.3,0.6-0.6,1-1\n\tc-0.8-0.8-1.6-1.6-2.4-2.4c0.7-0.7,1.3-1.3,2-2c0.5,0.5,1,1,1.5,1.5c0.3-0.3,0.6-0.6,1-1c-0.5-0.5-1-1-1.5-1.5c0.7-0.7,1.3-1.3,2-2\n\tc0.8,0.8,1.6,1.6,2.4,2.4c0.3-0.3,0.6-0.6,1-1c-0.8-0.8-1.6-1.6-2.4-2.4c0.7-0.7,1.3-1.3,2-2c0.5,0.5,1,1,1.5,1.5\n\tc0.3-0.3,0.6-0.6,1-1c-0.5-0.5-1-1-1.5-1.5c0.7-0.7,1.3-1.3,2-2c0.8,0.8,1.6,1.6,2.4,2.4c0.3-0.3,0.6-0.6,1-1\n\tc-0.8-0.8-1.6-1.6-2.4-2.4c0.7-0.7,1.3-1.3,2-2c0.5,0.5,1,1,1.5,1.5c0.3-0.3,0.6-0.6,1-1c-0.5-0.5-1-1-1.5-1.5\n\tc1.3-1.3,2.6-2.6,3.9-3.9c0.3-0.3,0.7-0.3,1,0c1.6,1.6,3.3,3.3,4.9,4.9C113.7,13.8,113.7,14.2,113.5,14.5z"
    }, null, -1)
  ])))
}
export default { render: render }